import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';
import { IUnifyJob } from '../../../app/models/unifyjob';
import UnifyJobStore from '../../../app/stores/unifyjobsStore';


interface DetailParams {
  id: string;
}

const UnifyJobEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const unifyjobStore = useContext(UnifyJobStore);
  const {
    createUnifyJob,
    editUnifyJob,
    submitting,
    loadUnifyJob,
    clearUnifyJob,
    loadingInitial
  } = unifyjobStore;

  const [unifyjob, setUnifyJob] = useState<IUnifyJob>({
    id: '',
    createdAt: '',
    updatedAt: '',
    financialYear: '',
    payRun: '',
    workOrderNumber:'',
    tech:'',
    startDate: '',
    hours: 0,
    sorId: '',
    description: '',
    comment:''
  });
  

   
  useEffect(() => {
    loadUnifyJob(match.params.id)
    .then(unifyjob => {
      setUnifyJob(unifyjob);}
    );

    return () => {
      clearUnifyJob();
    }
  }, [loadUnifyJob]);
  

  const handleSubmit = () => { 
     editUnifyJob(unifyjob).then(() => history.push(`/financemanagement/unifyjob`));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setUnifyJob({ ...unifyjob, [name]: value });
  };


  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
      <Form.Input
          label='Financial Year'
          onChange={handleInputChange}
          name='financialYear'
          placeholder='Financial Year'
          value={unifyjob.financialYear}
        />
        <Form.Input
          label='Pay Run'
          onChange={handleInputChange}
          name='payRun'
          placeholder='Pay Run'
          value={unifyjob.payRun}
        />
        <Form.Input
          label='Work Order No.'
          onChange={handleInputChange}
          name='workOrderNumber'
          placeholder='Work Order No.'
          value={unifyjob.workOrderNumber}
        />
        <Form.Input
          label='Tech'
          onChange={handleInputChange}
          name='tech'
          placeholder='Tech'
          value={unifyjob.tech}
        />
        <Form.Input
          label='Start Date'
          onChange={handleInputChange}
          name='startDate'
          type='date'
          placeholder='Date'
          value={unifyjob.startDate}
        />
        
        <Form.Input
          label='Hours'
          onChange={handleInputChange}
          name='hours'
          placeholder='Hours'
          value={unifyjob.hours}
        />
        <Form.Input
          label='SOR ID'
          onChange={handleInputChange}
          name='sorId'
          placeholder='SOR ID'
          value={unifyjob.sorId}
        />
        
        <Form.Input
          label='Description'
          onChange={handleInputChange}
          name='description'
          placeholder='Description'
          value={unifyjob.description}
        />
         <Form.Input
          label='Comment'
          onChange={handleInputChange}
          name='comment'
          placeholder='Comment'
          value={unifyjob.comment}
        />
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => history.push('/financemanagement/unifyjob')}
          floated='right'
          type='button'
          content='Cancel'
        />
      </Form>
    </Segment>
  );
};

export default observer(UnifyJobEditForm);
